import React from "react"

import { AppTransmissionAutocomplete } from "@components/Autocomplete"
import { transmission } from "@signals"
import { BACKEND_APIS } from "@constants"


export default function AppCommonFiltersTransmissionAutocomplete({ ...props }) {
	return <AppTransmissionAutocomplete
		value={transmission.value}
		onChange={e => transmission.value = e.target.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/transmission`}
		{...props}
	/>
}